import type { Settings, SettingsInput } from '@shop-monorepo/types';
import { useMutation, useQuery } from '@tanstack/react-query';
import { message } from 'antd';

import { apiClient } from '../services/api';

const SETTINGS_QUERY_KEY = ['settings'];

export const useSettings = () => {
  return useQuery<Settings, Error>({
    queryKey: SETTINGS_QUERY_KEY,
    queryFn: () => apiClient.settings.get(),
  });
};

export const useUpdateSettings = () => {
  return useMutation<Settings, Error, SettingsInput>({
    mutationFn: (data) => apiClient.settings.update(data),
    meta: { invalidates: [SETTINGS_QUERY_KEY] },
    onSuccess: () => {
      message.success('Налаштування збережено');
    },
    onError: (e) => {
      message.error(e.message);
    },
  });
};
